import CONSTANTS from "../../../src/components/Core/constants"

export function startSignalRConnection() {
    const userDetails = JSON.parse(localStorage.getItem('user_details'))

    if (!userDetails || !window.signalR) {
        console.warn("Missing user data or SignalR not loaded")
        return Promise.reject("SignalR init skipped")
    }

    const connection = new window.signalR.HubConnectionBuilder()
        .withUrl(`${CONSTANTS.WSO2BASEURL}/signalr/hubs`, {
            accessTokenFactory: () => localStorage.getItem('access_token'),
            headers: {
                loggedInUserId: userDetails.empId
            }
        })
        .withAutomaticReconnect()
        .configureLogging(window.signalR.LogLevel.Information)
        .build()

    window.signalRConnection = connection

    let tryingToReconnect = false
    let disconnected = false

    connection.onreconnecting(() => {
        console.log('reconnecting')
        tryingToReconnect = true
    })

    connection.onreconnected(() => {
        console.log('reconnected_automatically')
        tryingToReconnect = false
    })

    connection.onclose(() => {
        if (tryingToReconnect) {
            console.log('disconnected_reconnected from function')
            setTimeout(() => connection.start(), 500)
        } else {
            console.log('disconnected')
            disconnected = true
        }
    })

    document.body.addEventListener('click', () => {
        if (disconnected) {
            console.log('disconnected_reconnected from click')
            setTimeout(() => {
                disconnected = false
                connection.start()
            }, 500)
        }
    })

    // --- SignalR Listeners ---
    connection.on('receiveTestSignal', message => {
        alert(message)
    })

    connection.on('logOut', essUrl => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('user_details')
        window.location.href = essUrl
    })

    connection.on('redirectToSelectOrganization', essUrl => {
        window.location.href = `${essUrl}/SelectOrganization`
    })

    connection.on('refreshProfileAlerts', () => {
        window.bus.fire('refreshProfileAlertsListener', '')
    })

    connection.on('AddSoozeDateTimeSignal', model => {
        window.bus.fire('AddSoozeDateTimeSignalListener', model)
    })

    connection.on('showSnoozeNotificationPopup', model => {
        console.log(model)
        if (window.bus._events.showSnoozeNotificationListener1.length > 1) {
            const len = window.bus._events.showSnoozeNotificationListener1.length
            window.bus._events.showSnoozeNotificationListener1 =
                window.bus._events.showSnoozeNotificationListener1.slice(len - 1)
        }
        window.bus.fire('showSnoozeNotificationListener1', model)
    })

    connection.on('SendI983RefreshSignal', () => {
        window.bus.fire('SendI983RefreshSignal', '')
    })

    connection.on('showSnoozeNotificationCountPopup', count => {
        console.log(count)
        window.bus.fire('showSnoozeNotificationCountPopup', count)
    })

    connection.on('SendTimesheetStatusSignal', obj => {
        window.bus.fire('changeTimesheetStatus', obj)
    })

    connection.on('SendTimesheetReportProgressBarStatusSignal', obj => {
        console.log(obj)
        if (window.bus._events.SendTimesheetReportProgressBarStatusSignal.length > 1) {
            const len = window.bus._events.SendTimesheetReportProgressBarStatusSignal.length
            window.bus._events.SendTimesheetReportProgressBarStatusSignal =
                window.bus._events.SendTimesheetReportProgressBarStatusSignal.slice(len - 1)
        }
        window.bus.fire('SendTimesheetReportProgressBarStatusSignal', obj)
    })

    connection.on('openChangeRolePopUp', model => {
        window.bus.fire('roleChangeListener_v1', model)
    })

	connection.on('SendPMSRefreshSignal', () => {
        window.bus.fire('refreshPMStab')
    })

    return connection.start()
        .then(() => {
            console.log('SignalR connected successfully')
            return connection
        })
        .catch(err => {
            console.error('SignalR connection failed', err)
            throw err
        })
}



//////////////////
// WEBPACK FOOTER
// ./static/Js/Signalr-Scripts/signalR.js
// module id = null
// module chunks = 